'use es6';

import { Subscription } from '../Records';
import { parseSubscriptionTypes, sortBy } from './sharedPreferences';
window.emailUnsubscribeData = {};
export const prepareBrandData = brandInfoData => {
  if (brandInfoData === undefined) {
    return;
  }
  window.emailUnsubscribeData.company = {
    logoUrl: brandInfoData.logoUrl,
    name: brandInfoData.companyName
  };
};
export const prepareSubscriptionsData = (email, subscriptionData) => {
  if (subscriptionData === undefined) {
    return;
  }
  const {
    portalUnsubscribed,
    subscriptions
  } = subscriptionData;
  if (subscriptions.length === 0) {
    window.emailUnsubscribeData.subscriptionData = {
      optOutAllSubscriptions: true
    };
    return;
  }
  const {
    optedInIds,
    originalIds,
    types
  } = parseSubscriptionTypes({
    portalUnsubscribed,
    subscriptions,
    SubscriptionType: Subscription
  });
  window.emailUnsubscribeData.subscriptionData = {
    brandId: null,
    email,
    hasEmail: !!email,
    optedInIds,
    originalIds,
    originalOptedInIds: optedInIds,
    types: types.sort(sortBy('order'))
  };
};